import { GetServerSideProps } from "next";

export const getServerSideProps: GetServerSideProps = async () => {
  return {
    redirect: {
      destination: "/sitemap.xml",
      permanent: true,
    },
  };
};

export default function SitemapIndex() {}
